import React from 'react';

import classnames from 'classnames';

import { useSearch } from '../../../hooks/context';
import { FILTERS } from '../../../constants';
import useFilterRange from '../../../hooks/use-filter-range';
import ButtonFilter from './components/filter-button';
import { namespace, test_id, type_range, RangeFilterPropTypes, onlyNumbersPattern } from './constants';
import { STYLE_MODIFIERS } from '../../sidebar/components/filters/constants';
import { withComponentHandler } from '../../../hocs/with-component-handler';
import { RangeContent } from './components/range-content';
import { RangeContainer } from './components/range-container';

const { IDS } = FILTERS;
/**
 * Desktop range filter component
 * @param {Object} props - Component props
 * @param {string | null} [props.activeCurrencyId] - Active currency
 * @param {string} props.id - Filter ID
 * @param {string} props.fragment - URL fragment
 * @param {Object} props.labels - Filter labels
 * @param {string} props.labels.apply - Filter labels
 * @param {string} [props.url] - Base URL
 * @param {string} [props.id] - Base URL
 * @param {Array} props.values - Filter values
 * @returns {JSX.Element} Range filter component
 */

const FilterRange = ({ labels, values, url, activeCurrencyId, id, fragment }) => {
  const isYearFilter = id === IDS.VEHICLE_YEAR;
  const IdModifier = isYearFilter ? STYLE_MODIFIERS.YEAR_RANGE : id;
  const rangeType = isYearFilter ? type_range.dropdown : type_range.input;
  const filteredValues = rangeType === type_range.dropdown ? values : [];

  const { shops } = useSearch();
  const isShops = Boolean(shops);

  const { handleChangeDropdown, handleInputChange, handleOnSubmit, labelsData, disabled, setDropdownItemSelected } =
    useFilterRange({
      filterId: id,
      labels,
      url,
      activeCurrencyId,
      type: rangeType,
      fragment,
    });

  const className = classnames(namespace.base, `${namespace.base}--${IdModifier}`, {
    [namespace.shops.base]: isShops,
  });

  return (
    <RangeContainer handleOnSubmit={handleOnSubmit} className={className}>
      <RangeContent
        labelsData={labelsData}
        IdModifier={IdModifier}
        namespace={namespace}
        rangeType={rangeType}
        handleInputChange={handleInputChange}
        handleChangeDropdown={handleChangeDropdown}
        setDropdownItemSelected={setDropdownItemSelected}
        filteredValues={filteredValues}
        onlyNumbersPattern={onlyNumbersPattern}
        isShops={isShops}
        desktop
      />
      <ButtonFilter disabled={disabled} className={namespace} ariaLabel={labels.apply} testId={test_id} />
    </RangeContainer>
  );
};

FilterRange.propTypes = RangeFilterPropTypes;

export default withComponentHandler(FilterRange, { componentName: 'FilterRange' });
